import { get } from "@ember/object"
import Route from "@ember/routing/route"
import { inject as service } from "@ember/service"
import _ from "lodash"

export default class ChapterRoute extends Route {
  @service("ember-store")
  store

  model(params) {
    let id = _.last(_.split(params.article_id, "-"))
    return get(this, "store").find("kb-entry", id)
  }
}
